import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackActions from '../../actions/trackActions';
import TurnMeUp from './TurnMeUp.js';
import PlayPauseButtons from './PlayPauseButtons';
import * as browserCheck from '../../utils/browserCheck.js';
import AnalyticsService from '../../services/analyticsService';

class PlayerBar extends Component {
    
    constructor(props, context) {
        super(props, context);

        this.currentScroll;
        this.playerBarInit = true;
        this.played = false;
        this.roleIDsPlayed = [];
    
        this.PlayerEnded = this.PlayerEnded.bind(this);
        this.HandlePlayerError = this.HandlePlayerError.bind(this);
        this.HandlePlayEvent = this.HandlePlayEvent.bind(this);
        this.HandlePauseEvent = this.HandlePauseEvent.bind(this);
        this.PlayerBarAction = this.PlayerBarAction.bind(this);
        if(browserCheck.canUseDom()) {
            $(window).on('scroll', function () {
                //-- Close playerbar on scroll
                if (!this.playerBarInit && Math.abs(($(window).scrollTop() - this.currentScroll)) > 100) {
                    $('.playerbar').removeClass('withcontrol');
                }
            });        
             
            //this should be triggered whenever a track is played, not here. Have a playerService?
            setTimeout(function(){
                $('.playerbar').removeClass('withcontrol');
            }, 2000);     
        
            //-- Mobile volume control
            $('.btn-volume').on('click', function(e){
                e.preventDefault();
                $('.playerbar-volume').toggleClass('showvol');
            });
        }
    }

    componentDidMount() {
        $("#jquery_jplayer_1").jPlayer({
            solution: "html",
            supplied: "mp3",
            cssSelectorAncestor: "#playerbar",
            cssSelector: {
                play: "#play",
                pause: "#pause",
                stop: "#stop",
                mute: "#mute",
                unmute: "#unmute",
                seekBar: "#seekBar",
                playBar: "#playBar",
                currentTime: "#currentTime",
                duration: "#duration",
                volumeBar: "#volumeBar",
                volumeBarValue: "#volumeBarValue"
            },
            size: {
                width: "0px",
                height: "0px"
            },
            ended: this.PlayerEnded,
            error: this.HandlePlayerError,
            play: this.HandlePlayEvent,
            pause: this.HandlePauseEvent,
            volumechange: this.HandleVolumeChangeEvent
        });
    }          
    
    shouldComponentUpdate(nextProps, nextState) {
        const getTrackIDOrRatingChanged = () => this.props.nowPlaying && nextProps.nowPlaying && (this.props.nowPlaying.ID != nextProps.nowPlaying.ID || this.props.nowPlaying.Rating != nextProps.nowPlaying.Rating);
        const getPlayingStatusChanged = () => this.props.trackPlaying != nextProps.trackPlaying
        const getPausedStatusChanged = () => this.props.trackPaused != nextProps.trackPaused;        
        const getTrackUrlChanged = () => this.props.nowPlaying.Url != nextProps.nowPlaying.Url;
        return getTrackIDOrRatingChanged() || getPlayingStatusChanged() || getPausedStatusChanged() || getTrackUrlChanged();
    }

    componentDidUpdate(prevProps, prevState) {
        //do the jplayer stuff here depending on what's changed, the render function should take care of the re-rendering
        if(this.props.nowPlaying.ID) {
            const trackChanged = this.props.nowPlaying.ID != prevProps.nowPlaying.ID;
            const playSelected = this.props.trackPlaying && !prevProps.trackPlaying;
            const haveTrackUrl = !!this.props.nowPlaying.Url;
            const trackUrlChanged = this.props.nowPlaying.Url && !prevProps.nowPlaying.Url;
            //as long as we have a track url to play and the user has changed the track, or clicked play, start playing it
            if(haveTrackUrl && (playSelected || trackUrlChanged)) {
                this.PlayMusic();
            }            
            else if(trackChanged && !haveTrackUrl) {
                //we've changed the track but aren't yet ready to play it. stop the current track, we'll either get the new track url next or it will error
                this.ResetPlayer();
            }
            else if(this.props.trackPaused != prevProps.trackPaused) {
                this.PauseMusic();
            }
        }
    }

    HandlePlayEvent(e) {
        if(!this.props.trackPlaying) {
            //the user has played from their keyboard or some other way that didn't require clicking the play button so update the status
            this.props.actions.setTrackStatus(true, false);
        }
    }

    HandlePauseEvent(e) {        
        if(!this.props.trackPaused) {
            //the user has paused from their keyboard or some other way that didn't require clicking the pause button so update the status
            this.props.actions.setTrackStatus(false, true);
        }
    }

    HandleVolumeChangeEvent(e) {
        console.log('volume changed');
    }
        
    PlayerBarAction(e) {
        e.preventDefault(); 
        this.playerBarInit = false;
        this.currentScroll = $(window).scrollTop();            
        $('.playerbar').toggleClass('withcontrol');
    }

    PlayerEnded(event) {
        this.props.actions.setTrackStatus(false, false);
    }

    HandlePlayerError(event) {
        const trackID = this.props.nowPlaying.ID;
        this.props.actions.setTrackStatus(false, false);
        if (event.jPlayer.error.type === $.jPlayer.error.URL) {
            this.props.actions.reportBrokenTrack(trackID);            
        }    
    }    
    
    PlayMusic() {
        const currentUrl = $('#jquery_jplayer_1').data().jPlayer.status.src;
        if (this.props.nowPlaying.Url == currentUrl) {
            $('#jquery_jplayer_1').jPlayer("play"); //just play so can be resumed from the previous position
        }
        else {
            $('#jquery_jplayer_1').jPlayer("setMedia", {
                mp3: this.props.nowPlaying.Url
            }).jPlayer("play");

            //$('#aSoundCloud').attr('href', this.props.nowPlaying.DescriptionUrl);
            if ($('#volumeBar:visible').length == 0) {
                $('#volumeBox').hide();
            }

            //log the track play
            let ownTrack = false;
            if(this.props.nowPlaying && this.props.nowPlaying.RoleID) {
                if(this.props.user) {
                    ownTrack = this.props.user.enabledProfiles.map(p => p.ID).includes(this.props.nowPlaying.RoleID);
                }
                if(!ownTrack) {
                    if(!this.roleIDsPlayed.includes(this.props.nowPlaying.RoleID)) {
                    this.roleIDsPlayed.push(this.props.nowPlaying.RoleID);
                    }
                    if(this.roleIDsPlayed.length > 1) {
                        //they've played tracks by more than 1 artist, flag them
                        AnalyticsService.logEventFB('Lead', false);
                        AnalyticsService.logEventFB('TrackPlayed', true, { roleId: this.props.nowPlaying.RoleID });
                    }
                }
            }
        }
        //fire off the set trackStatus action
        this.props.actions.setTrackStatus(true, false);
    }

    PauseMusic() {
        $('#jquery_jplayer_1').jPlayer('pause');
    }

    ResetPlayer() {
        $('#jquery_jplayer_1').jPlayer('clearMedia');
    }

    render() {
        return (
            <div>                
                <div id="playerbar" className="playerbar withcontrol">     
                    <div id="loudboxContainer" />
                    {/*Tune and control*/}
                    <div className="playerbar-author">      
                        <div className="playerbar-control">
                            {this.props.nowPlaying.ID ?
                                <PlayPauseButtons trackID={this.props.nowPlaying.ID} anchorClass="btn-playstop transition" spanClass="" playButtonClass="icon icn-bigplay transition" pauseButtonClass="icon icn-bigpause transition" />  
                                :null}
                            {this.props.trackPlaying && this.props.nowPlaying.Url ?
                            <div className="playicon">
                                <span className="no1" />
                                <span className="no2" />
                                <span className="no3" />
                                <span className="no4" />
                            </div> : null} 
                        </div>

                        <div className="playerbar-tune">        
                            <p className="artist">
                                {
                                    this.props.nowPlaying.RoleUsername ? 
                                        <Link to={`/${this.props.nowPlaying.RoleUsername}`} className="btn-artist transition" id="playerArtistName">{this.props.nowPlaying.RoleDisplayName || ''}</Link>
                                        :
                                        <span>Loading...</span>
                                }
                                
                            </p>
                            {this.props.nowPlaying.TrackName && <p className="tune"><span id="playerTrackName">{this.props.nowPlaying.TrackName}</span></p>} 
                        </div>
                    </div>
            
                    {/* Duration */}
                    <div className="playerbar-duration playerbar-duration-simple">
                
                        <p className="time">
                            <span id="currentTime">00:00</span>
                            <span> / </span>
                            <span className="duration" id="duration">00:00</span>
                        </p>                
                        <div id="seekBar" className="playtime">
                            <div id="playBar" className="playhead" style={{width: '2%'}} />
                        </div>
                    </div>   
            
                    {/* Volume control */}    
                    <div className="playerbar-volume">
                        <div id="volumeBox" className="volumebox">
                            <svg className="icon icn-volume transition">
                                <use xlinkHref="#icn-volume" />
                            </svg>
                            <div id="volumeBar" className="playtime">
                                {/* TODO: remove the style tag below */}   
                                <div id="volumeBarValue" className="playhead" style={{width: '80%'}} />
                            </div>
                        </div>
                    </div>    
            
                    <div className="playerbar-loudup">      
                        <TurnMeUp id={this.props.nowPlaying.ID || 0} rating={this.props.nowPlaying.Rating || 0} roleID={this.props.nowPlaying.RoleID || 0} isMusic />
                    </div>    
            
                    <div className="playerbar-soundcloud">
                        <a id="aSoundCloud" href={this.props.nowPlaying.DescriptionUrl || '#'} className="btn-sound transition" target="_blank">
                            <img src={require('../../images/powered_by_soundcloud.png')} alt="Powered by SoundCloud" />
                            <span>Powered by SoundCloud</span>
                        </a>
                    </div>
            
                    {/* Duration -->*/}
                    <div className="playerbar-duration playerbar-duration-full">      
                        <p className="time">
                            <span id="currentTime">00:01</span>
                            <span>/</span>
                            <span className="duration" id="duration" />
                        </p>        
                        <div id="seekBar" className="playtime">
                            {/*TODO: remove the style tag below*/}
                            <div id="playBar" className="playhead" style={{width: '35%'}} />
                        </div>
                    </div>    
                    <div onClick={this.PlayerBarAction}>
                        <div className="playerbar-action" />   
                        <span className="caret" />
                    </div>
                </div>
                <div id="jquery_jplayer_1" className="jp-jplayer" />
            </div>
        );
    }
}

PlayerBar.propTypes = {
    nowPlaying: PropTypes.object,
    trackPlaying: PropTypes.bool.isRequired,
    trackPaused: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    user: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return { 
        nowPlaying: state.tracks.nowPlaying, 
        trackPlaying: state.tracks.trackPlaying, 
        trackPaused: state.tracks.trackPaused,
        user: state.account.user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlayerBar);
